import { FC, useState } from 'react'
import { Alert, Divider, Input, Form } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../../ui'
import { ButtonsBlock } from '../../../../Edit/components'
import useRequest from '../../../../hooks/useRequest'
import { postApprove } from '../../../config'
import style from './style.m.less'
import {useCurrentUser} from "../../../../hooks/useCurrentUser";
import IAppState from 'store/states'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {signBody} from "../../../../helpers";
import { useTranslation } from 'react-i18next'
const { TextArea } = Input

interface IRefuseModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    currentDate: string
    generatorName: string
    id?: string
}

const RefuseModal: FC<IRefuseModal> = ({
    isModalVisible,
    setIsModalVisible,
    currentDate,
    id,
    generatorName,
}) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { fetch } = useRequest(postApprove)
    const userInfo = useSelector((store: IAppState) => store.user)
    const { data } = userInfo
    const { isUserAdmin } = useCurrentUser()
    const isEmptySign = isUserAdmin && !data?.certificate_data
    const isSignExpired = isUserAdmin && !isEmptySign && !moment(data?.certificate_data.token_expiration).isAfter()

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const onFinish = async ({ reason }: { reason: string }) => {
        const body = {
            fuel_application_id: Number(id),
            approve_type: 2,
            fuel_application_comment: reason,
        }
        if (isUserAdmin) {
            const {request_id, signature} = await signBody(body, data)
            fetch({
                body,
                getParams: {
                    request_id,
                },
                config: {
                    headers: {
                        Signature: signature,
                    },
                },
                successMessage: {
                    title: 'Отказ отправлен',
                    description: `Данные по топливу за ${currentDate} по ЗГО ${generatorName} отклонены, комментарий направлен пользователю`,
                },
                errorCodeMessage: true,
                onSuccess: () => navigate('/fuel-approval'),
            })
        } else {
            fetch({
                body,
                successMessage: {
                    title: 'Отказ отправлен',
                    description: `Данные по топливу за ${currentDate} по ЗГО ${generatorName} отклонены, комментарий направлен пользователю`,
                },
                errorCodeMessage: true,
                onSuccess: () => navigate('/fuel-approval'),
            })
        }
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <Form onFinish={onFinish}>
                <div className={style.modalWrapper}>
                    <div className={style.header}>Отказ в согласовании данных</div>
                </div>
                <div className={style.text}>
                    <div>Причина отказа</div>
                    <Form.Item
                        name="reason"
                        rules={[
                            { required: true, message: 'Поле должно быть заполнено' },
                            {
                                max: 500,
                                message: 'Укажите комментарий длиной не больше 500 символов',
                            },
                        ]}
                    >
                        <TextArea
                            className={style.textArea}
                            rows={4}
                            placeholder="Ваш комментарий"
                        />
                    </Form.Item>
                </div>
                <Alert
                    className={style.modalAlert}
                    message="Указанный комментарий увидит пользователь"
                    type="warning"
                    showIcon
                />
                {(isEmptySign || isSignExpired) && (
                    <>
                        <Divider />
                        <Alert
                            className={style.signError}
                            message={isEmptySign ? 'Не установлена ЭП' : 'Истек срок действия ЭП'}
                            type="error"
                            showIcon
                        />
                    </>
                )}
                <div className={style.buttonsBlock}>
                    <ButtonsBlock
                        cancelAction={handleOk}
                        confirmTitle={isUserAdmin
                            ? t('questionnaireApprovalItem.signModalButtonTitle')
                            : t('questionnaireApprovalItem.modalButtonTitle')}
                        confirmDisabled={isEmptySign || isSignExpired}
                    />
                </div>
            </Form>
        </Modal>
    )
}

export default RefuseModal
